import { History } from "./../models/history";

import BaseService from "./_base.service";

const endpoint = "storage-box/histories";

const StorageBoxHistoriesService = {
  ...BaseService<History>({ endpoint }),
};

export default StorageBoxHistoriesService;
